import { VestingSafeSource } from '@profile/src/models';
export const options = [{
  label: 'Vesting Safe',
  id: VestingSafeSource.VESTING_CLAIM.toString()
}, {
  label: 'Thetan Tournament',
  id: VestingSafeSource.SPECIAL_EVENT_REWARD.toString()
}, {
  label: 'Admin',
  id: VestingSafeSource.ADMIN.toString()
}, {
  label: 'Creator Program Creator',
  id: VestingSafeSource.CREATOR_PROGRAM_CREATOR.toString()
}, {
  label: 'Fusion Reward',
  id: VestingSafeSource.FUSION_CASHBACK.toString()
}, {
  label: 'Fusion Competition Reward',
  id: VestingSafeSource.FUSION_LEADERBOARD.toString()
}, {
  label: 'Trading Event Reward',
  id: VestingSafeSource.TRADING_EVENT_CASHBACK.toString()
}, {
  label: 'Trading Event Competition Reward',
  id: VestingSafeSource.TRADING_EVENT_LEADERBOARD.toString()
}];